import '../styles/components/footer.css'

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Parkort</h3>
          <p>Bedre kommunikation gennem ærlige svar</p>
        </div>
        
        <div className="footer-section">
          <h4>Legal</h4>
          <ul>
            <li><a href="/dist/privacy-policy">Privatlivspolitik</a></li>
            <li><a href="/dist/terms-of-service">Vilkår og Betingelser</a></li>
            <li><a href="/dist/cookie-policy">Cookiepolitik</a></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Om</h4>
          <ul>
            <li><a href="/dist/about">Om Parkort</a></li>
            <li><a href="mailto:info@thomasvalenzuela.com">Kontakt</a></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Følg Os</h4>
          <p style={{ fontSize: '0.9em', color: 'var(--text-secondary)' }}>
            (Sociale medier links kan tilføjes senere)
          </p>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Parkort. Alle rettigheder forbeholdes.</p>
      </div>
    </footer>
  )
}

export default Footer
